// @flow

/**
 * Module dependencies.
 */

import { get, startCase } from 'lodash';
import { resolveApiUrl } from 'core/utils';
import React, { Component } from 'react';
import axios from 'axios';

/**
 * `formSubmitWrapper` component.
 */

export default function formSubmitWrapper(FormComponent: any) {
  /**
   * `Props` type.
   */

  type Props = {
    subject: string,
    subjectField?: string
  };

  return class extends Component {

    /**
     * Props.
     */

    props: Props;

    /**
     * Initial state.
     */

    initialState: Object = {
      error: false,
      fullfilled: false,
      pending: false
    }

    /**
     * State.
     */

    state: Object = {
      ...this.initialState
    };

    /**
     * Set initial state.
     */

    setInitialState = () => {
      this.setState(this.initialState);
    }

    /**
     * Form submission.
     */

    onSubmit = async (data: any) => {
      const { subject, subjectField } = this.props;
      const reason = get(data, subjectField);
      const suffix = subjectField ? ` - ${startCase(reason)}` : '';

      if (this.state.pending) {
        return;
      }

      this.setState({
        error: false,
        fullfilled: false,
        pending: true
      });

      try {
        await axios.post(
          resolveApiUrl('tickets'),
          {
            ...data,
            subject: `${subject}${suffix}`
          }
        );
      } catch (error) {
        this.setState({
          error: true,
          fullfilled: false,
          pending: false
        });

        return;
      }

      this.setState({
        error: false,
        fullfilled: true,
        pending: false
      });
    }

    /**
     * Render
     */

    render(): React$Element<*> {
      const { subject, subjectField } = this.props;
      const { error, fullfilled, pending } = this.state;

      return (
        <FormComponent
          {...this.props}
          fullfilled={fullfilled}
          onReset={this.setInitialState}
          onSubmit={this.onSubmit}
          pending={pending}
          subject={subject}
          subjectField={subjectField}
          submissionError={error}
        />
      );
    }

  };
}



// WEBPACK FOOTER //
// ../src/client/components/forms/components/form-submit-wrapper.js